import {
  backendURLFormatter,
  organizationsFormatter,
} from './organizationsFormatter';
import { subdomainGetter } from './subdomainGetter';

export const getOrganization = () =>
  process.env.REACT_APP_AUTH0_ORGANIZATIONS
    ? organizationsFormatter(process.env.REACT_APP_AUTH0_ORGANIZATIONS)[
        subdomainGetter()
      ]
    : null;

export const getBackendUrl = () =>
  process.env.REACT_APP_BACKEND_URL
    ? backendURLFormatter(process.env.REACT_APP_BACKEND_URL)[subdomainGetter()]
    : 'https://16os6itym8.execute-api.us-east-2.amazonaws.com/dev/';

export const getSSOFlag = () =>
  process.env.REACT_APP_AUTH0_SSO
    ? organizationsFormatter(process.env.REACT_APP_AUTH0_SSO)[subdomainGetter()]
    : null;
